/* This file is auto-generated */

import type { ContractPromise } from '@polkadot/api-contract';
import type { KeyringPair } from '@polkadot/keyring/types';
import type { SignerOptions } from '@polkadot/api/submittable/types';
import type { ApiPromise } from '@polkadot/api';
import type { GasLimit, GasLimitAndRequiredValue, Result } from '@arthswap/typechain-types';
import { txSignAndSend } from '@arthswap/typechain-types';
import type * as ArgumentTypes from '../types-arguments/factory_contract';
import type BN from 'bn.js';


export default class Methods {
	private __nativeContract : ContractPromise;
	private __keyringPair : KeyringPair;
	private __apiPromise: ApiPromise;

	constructor(
		apiPromise: ApiPromise,
		nativeContract : ContractPromise,
		keyringPair : KeyringPair,
	) {
		this.__apiPromise = apiPromise;
		this.__nativeContract = nativeContract;
		this.__keyringPair = keyringPair;
	}

	/**
	* allPairsLength
	*
	*/
	"allPairsLength" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::allPairsLength",
			[], __options, __signerOptions);
	}

	/**
	* lockForPairCreate
	*
	*/
	"lockForPairCreate" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::lockForPairCreate",
			[], __options, __signerOptions);
	}

	/**
	* pairContractCodeHash
	*
	*/
	"pairContractCodeHash" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::pairContractCodeHash",
			[], __options, __signerOptions);
	}

	/**
	* unlockPairCreate
	*
	*/
	"unlockPairCreate" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::unlockPairCreate",
			[], __options, __signerOptions);
	}

	/**
	* setFeeTo
	*
	* @param { ArgumentTypes.AccountId } feeTo,
	*/
	"setFeeTo" (
		feeTo: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::setFeeTo",
			[feeTo], __options, __signerOptions);
	}

	/**
	* feeTo
	*
	*/
	"feeTo" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::feeTo",
			[], __options, __signerOptions);
	}

	/**
	* getPair
	*
	* @param { ArgumentTypes.AccountId } tokenA,
	* @param { ArgumentTypes.AccountId } tokenB,
	*/
	"getPair" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::getPair",
			[tokenA, tokenB], __options, __signerOptions);
	}

	/**
	* createPair
	*
	* @param { ArgumentTypes.AccountId } tokenA,
	* @param { ArgumentTypes.AccountId } tokenB,
	*/
	"createPair" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::createPair",
			[tokenA, tokenB], __options, __signerOptions);
	}

	/**
	* lockPairCreate
	*
	*/
	"lockPairCreate" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::lockPairCreate",
			[], __options, __signerOptions);
	}

	/**
	* allPairs
	*
	* @param { (number | string | BN) } pid,
	*/
	"allPairs" (
		pid: (number | string | BN),
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::allPairs",
			[pid], __options, __signerOptions);
	}

	/**
	* getBootstrap
	*
	* @param { ArgumentTypes.AccountId } tokenA,
	* @param { ArgumentTypes.AccountId } tokenB,
	*/
	"getBootstrap" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::getBootstrap",
			[tokenA, tokenB], __options, __signerOptions);
	}

	/**
	* setBootstrap
	*
	* @param { ArgumentTypes.AccountId } tokenA,
	* @param { ArgumentTypes.AccountId } tokenB,
	* @param { ArgumentTypes.AccountId } bootstrap,
	*/
	"setBootstrap" (
		tokenA: ArgumentTypes.AccountId,
		tokenB: ArgumentTypes.AccountId,
		bootstrap: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::setBootstrap",
			[tokenA, tokenB, bootstrap], __options, __signerOptions);
	}

	/**
	* setFeeToSetter
	*
	* @param { ArgumentTypes.AccountId } feeToSetter,
	*/
	"setFeeToSetter" (
		feeToSetter: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "factory::setFeeToSetter",
			[feeToSetter], __options, __signerOptions);
	}

	/**
	* owner
	*
	*/
	"owner" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::owner",
			[], __options, __signerOptions);
	}

	/**
	* renounceOwnership
	*
	*/
	"renounceOwnership" (
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::renounceOwnership",
			[], __options, __signerOptions);
	}

	/**
	* transferOwnership
	*
	* @param { ArgumentTypes.AccountId } newOwner,
	*/
	"transferOwnership" (
		newOwner: ArgumentTypes.AccountId,
		__options ? : GasLimit,
		__signerOptions ? : Partial<SignerOptions>,
	){
		return txSignAndSend( this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::transferOwnership",
			[newOwner], __options, __signerOptions);
	}

}
